import { type ReactNode } from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BAR =
  'flex items-center justify-between gap-md border-t border-white/[0.06] pt-base';

type BarProps = {
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
};

function ConfirmActions(p: BarProps): ReactNode {
  return (
    <div className="flex gap-sm">
      <Button variant="ghost" size="sm" onClick={p.onCancel}>
        Cancelar
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.pending}
      >
        Generar
      </Button>
    </div>
  );
}

export function ResetConfirmBar(p: BarProps): ReactNode {
  return (
    <div className={BAR}>
      <p className="text-xs text-text-secondary">
        ¿Generar nueva contrase&ntilde;a temporal? El usuario deber&aacute;
        cambiarla al iniciar sesi&oacute;n.
      </p>
      <ConfirmActions {...p} />
    </div>
  );
}

function copyToClipboard(text: string): void {
  void globalThis.navigator.clipboard.writeText(text);
}

function PwdBox({ pwd }: { pwd: string }): ReactNode {
  return (
    <div className="flex items-center gap-sm rounded-md border border-white/[0.06] bg-white/[0.02] px-sm py-xs">
      <code className="flex-1 font-mono text-sm tabular-nums text-text-primary">
        {pwd}
      </code>
      <button
        onClick={() => copyToClipboard(pwd)}
        className="text-text-tertiary transition-colors hover:text-text-primary"
        title="Copiar"
      >
        <Copy size={14} />
      </button>
    </div>
  );
}

export function ResetReveal({
  pwd,
  onClose,
}: {
  pwd: string;
  onClose: () => void;
}): ReactNode {
  return (
    <div className="space-y-sm border-t border-white/[0.06] pt-base">
      <p className="text-[10px] uppercase tracking-wider text-text-tertiary/60">
        Contrase&ntilde;a temporal
      </p>
      <PwdBox pwd={pwd} />
      <p className="text-[11px] text-text-tertiary">
        Comp&aacute;rtela con el usuario por WhatsApp. Esta contrase&ntilde;a no
        se volver&aacute; a mostrar.
      </p>
      <div className="flex justify-end">
        <Button variant="primary" size="sm" onClick={onClose}>
          Entendido
        </Button>
      </div>
    </div>
  );
}
